import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CommonDataService } from '../../services/common-data.service';
import { GraphqlService } from '../../services/graphql.service';

@Component({
  selector: 'app-related-content',
  templateUrl: './related-content.component.html',
  styleUrls: ['./related-content.component.css']
})
export class RelatedContentComponent implements OnInit {

  constructor(private commonDataService: CommonDataService, private graphQlService: GraphqlService, private router: Router) { }

  @Output() myEvent = new EventEmitter<string>();

  title;
  content;
  subcontent: { subheader: any, Content: any, Links: any[] }[] = [];
  pageinitated: boolean = false;

  ngOnInit(): void {
    this.getrelatedcontentlabels();
  }



  getrelatedcontentlabels() {
    this.commonDataService.showLoader.next(true);
    this.graphQlService.getRelatedContentComponentLabels()
      .subscribe(data => {
        this.commonDataService.showLoader.next(false);

      let source = data.hits.hitsData[0].source;
      this.title = source.title;
        this.content = source.content;
        for (let item of source.subsections) {
        this.subcontent.push({ subheader: item.subsection,Content: item.content, Links:item.links});
        }
        this.pageinitated = true;

    })


  }

  Openlink(event) {
    this.router.navigate([event.currentTarget.id]);
    this.myEvent.emit();
  }
}
